
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.384 3L4.868 8.098a.272.272 0 00.033.392.29.29 0 00.186.066h2.005V13l4.515-5.098a.272.272 0 00-.033-.392.29.29 0 00-.185-.066H9.384V3z","fill":"#003653","fill-rule":"evenodd"}})])
          )
        }
      }
    